import type { EffectSection } from './sections';

/** Undo coalescing category for arrow-key nudges of one section: a held key
 *  is one undo entry (see resolveUndoPush's sliding window). */
export const effectNudgeUndoCategory = (id: string) => `effect-nudge:${id}`;

/** Category for a controls-row slider commit (intensity or the knob), so
 *  keyboard steps on one slider fold into one entry. Discrete edits (the ease
 *  toggle, a lane drag, add, delete) get none: each is its own entry. */
export function effectControlUndoCategory(id: string, patch: Partial<EffectSection>): string | undefined {
  if (patch.intensity !== undefined) return `effect-control:${id}:intensity`;
  const knobKey = patch.params ? Object.keys(patch.params)[0] : undefined;
  return knobKey ? `effect-control:${id}:${knobKey}` : undefined;
}
